

import React from 'react'
import { Redirect, Route } from 'react-router'
import ProTypes from 'prop-types'

export const PrivateRauter = ({
    isAuthenticated,
    component: Component,
    ...rest//el resto de los elemtos caeran aqui

}) => {

    console.log(rest)
    // odjeto => location => proiedades => hash:'' , key:'',patname:'search',state
    // odjeto -> computedMatch => propiedades => path='/', url:'/', isExact:false or true, params:{}

    localStorage.setItem('lastPath',rest.location.pathname)

    return (
        <Route {...rest}
            component={ (props) => (
                (isAuthenticated)
                    ? <Component {...props} />
                    : (<Redirect to="/login" />)
            )}
        />
    )
}
//ne secito ejecutar el la ruta del DashboardRoutes de manera 

PrivateRauter.prototype = {
    isAuthenticated: ProTypes.bool.isRequired,
    component: ProTypes.func.isRequired,

}